import { Component ,TemplateRef , OnInit , ViewChild,PLATFORM_ID ,Inject, Input } from '@angular/core';
import { CommonModule,isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { BreakpointObserver, BreakpointState, LayoutModule } from '@angular/cdk/layout';


import { MatDialog } from '@angular/material/dialog';

import {AnalysisServiceService } from '../../services/analysis-service/analysis-service.service';
import { FacadeService } from '../../services/facade.service';

@Component({
  selector: 'global-export',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    FormsModule,
    LayoutModule],
  templateUrl: './global-export.component.html',
  styleUrl: './global-export.component.css'
})
export class GlobalExportComponent {
  a_exportar = [true,true,true,true,true,true,true,true,true,true,true]
  selectAllChecked: boolean = true; // Estado del checkbox maestro
  // @Input() data= '';
  isExpanded = false;
  splitCharacter: string = '';
  dialogRef: any;
  inputValue: string = '#'; // Inicializa el valor del campo de texto

  englishType: string = 'british';//Variable de tipo de Ingles para cambiar la pestaña

  isScreenLarge: boolean = false;
  
  // Utilizamos @ViewChild para obtener una referencia al template
  @ViewChild('analysisOptionsDialog') analysisOptionsDialog!: TemplateRef<any>;

  // Analysis Service es para mandar los valores al Analysis Options
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    public dialog: MatDialog,
    private analysisService: AnalysisServiceService,
    private breakpointObserver: BreakpointObserver,
    private fachada: FacadeService,
    @Inject(MAT_DIALOG_DATA) public data: string) {
    
  }


  getCocaText(): string {
    return this.englishType === 'british' ? 'BNC' : 'COCA';
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.isScreenLarge = window.innerWidth > 1000;
      window.addEventListener('resize', this.onResize.bind(this));
    }

    // Abrir el cuadro de diálogo cuando se cargue el componente
    setTimeout(() => {
      this.openAnalysisOptions();
    }, 0);

    // Observa los cambios en el tamaño de la ventana
    this.breakpointObserver.observe(['(max-width: 1000px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        // Si el ancho es menor a 1000px, ajusta el tamaño del modal
        if (this.dialogRef) {
          this.dialogRef.updateSize('80%', '80%');
        }
      } else {
        // Si el ancho es mayor o igual a 1000px, usa el tamaño predeterminado
        if (this.dialogRef) {
          this.dialogRef.updateSize('45%', '80%');
        }
      }
    });

     // Funcion para saber si el tipo de Ingles es British o American
     this.analysisService.currentEnglishType.subscribe(type => {
      this.englishType = type;
      if (this.englishType == 'american'){
        this.a_exportar[6]=true
        this.a_exportar[7]=false
      }else{
        this.a_exportar[6]=false
        this.a_exportar[7]=true
      }
    });
  }

  onResize() {
    this.isScreenLarge = window.innerWidth > 1000;
  }


  // Método para abrir el diálogo
openAnalysisOptions(): void {
  // Cerrar el diálogo si ya está abierto
  if (this.dialogRef) {
    this.dialogRef.close();
  }

  const width = this.isScreenLarge ? '670px' : '80%';
  let height: string;

  if (this.isExpanded) {
    height = this.isScreenLarge ? '95%' : '80%';
  } else {
    height = this.isScreenLarge ? '550px' : '80%';
  }

  if (!this.isScreenLarge) {
    height = Math.min(window.innerHeight * 0.8, 750) + 'px'; // Máximo de 750px para dispositivos móviles
  }

  this.dialogRef = this.dialog.open(this.analysisOptionsDialog, {
    panelClass: 'custom-dialog-container',
    width: width,
    height: height,
    backdropClass: 'dialog-backdrop-dark'
  });

  // Ajustar el tamaño del diálogo si el ancho es menor a 1000px
  this.breakpointObserver.observe(['(max-width: 1000px)']).subscribe((state: BreakpointState) => {
    if (state.matches) {
      const newHeight = Math.min(window.innerHeight * 0.8, 750) + 'px'; // Máximo de 750px para dispositivos móviles
      this.dialogRef.updateSize('80%', newHeight);
    } 
  });
}

  // Método para alternar la apertura/cierre del diálogo
  toggleDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null; // Asegúrate de restablecer la referencia
    } else {
      this.openAnalysisOptions();
    }
  }

  toggleSelectAll(): void {
    // Sincroniza el estado del checkbox maestro con todos los checkboxes
    this.a_exportar.fill(this.selectAllChecked);
  }

  updateSelectAllState(): void {
    // Actualiza el estado del checkbox maestro si todos los checkboxes están seleccionados o no
    this.selectAllChecked = this.a_exportar.every(value => value === true);
  }

  exportar_datos() {
    // Verificar si todos los valores de a_exportar son false
    const allFalse = this.a_exportar.every(value => value === false);
  
    if (allFalse) {
      alert('No hay valores seleccionados');
    } else {
      console.log(this.data);
      this.fachada.export_general(this.a_exportar, this.data);
    }
  }
  
}
